import Vue from 'vue'
import axios from 'axios'
import { initCompany, initPublisher } from '../plugins/localStorage'

const state = {
  company: initCompany,
  publisher: initPublisher,
  status: {
    loading: false,
    error: false,
    message: ''
  }
}

const mutations = {
  setCompany (state, company) {
    state.company = JSON.stringify(company)
  },
  resetCompany (state) {
    state.company = ''
  },
  setPublisher (state, publisher) {
    state.publisher = JSON.stringify(publisher)
  },
  resetPublisher (state) {
    state.publisher = ''
  },
  setStatus (state, status) {
    Vue.set(state, 'status', status)
  }
}

const actions = {
  setStatus ({ commit }, status) {
    commit('setStatus', { loading: status.loading, error: status.error, message: status.message })
    return { success: true }
  },

  async populate ({ commit, rootGetters }, id) {
    // If user is organisation
    const endpoint = process.env.VUE_APP_BACKEND + '/organisation/' + id
    // const addresses = process.env.VUE_APP_BACKEND + '/addresses/search'
    const headers = { 'Authorization': 'Bearer ' + rootGetters['auth/getToken'] }
    commit('setStatus', { loading: true, error: false, message: '' })
    const response = await axios.get(endpoint, { headers: headers })
    // const response = await Promise.all([
    //   axios.get(endpoint, { headers: headers }),
    //   axios.post(addresses, { filter: { field: 'organisation_id', operator: '=', value: id } }, { headers: headers })
    // ])
    if (response.status === 200) {
      // response[0].data.addresses = response[1].data.data || []
      commit('setCompany', response.data)
      commit('setStatus', { loading: false, error: false, message: '' })
      return ({ success: true })
    } else {
      commit('setStatus', { loading: false, error: true, message: response.message })
      return ({ success: false })
    }
  },

  async populatePublisher ({ commit, rootGetters }, id) {
    // If user is publisher
    const endpoint = process.env.VUE_APP_BACKEND + '/publisher/' + id
    const headers = { 'Authorization': 'Bearer ' + rootGetters['auth/getToken'] }
    commit('setStatus', { loading: true, error: false, message: '' })
    const response = await axios.get(endpoint, { headers: headers })
    if (response.status === 200) {
      commit('setPublisher', response.data)
      commit('setStatus', { loading: false, error: false, message: '' })
      return ({ success: true })
    } else {
      commit('setStatus', { loading: false, error: true, message: response.message })
      return ({ success: false })
    }
  },

  /*async updateAddresses ({ commit, rootGetters }) {
    const addresses = process.env.VUE_APP_BACKEND + '/addresses/search'
    const headers = { 'Authorization': 'Bearer ' + rootGetters['auth/getToken'] }
    commit('setStatus', { loading: true, error: false, message: '' })
    const response = await axios.post(addresses, { filter: { field: 'organisation_id', operator: '=', value: rootGetters['company/getCompanyData'].id } }, { headers: headers })
    if (response.status === 200) {
      let updatedCompany = rootGetters['company/getCompanyData']
      updatedCompany.addresses = response.data.data
      commit('setCompany', updatedCompany)
      commit('setStatus', { loading: false, error: false, message: '' })
      return ({ success: true })
    } else {
      commit('setStatus', { loading: false, error: true, message: response.message })
      return ({ success: false })
    }
  },*/

  async edit ({ commit, dispatch, rootGetters }, company) {
    const endpoint = process.env.VUE_APP_BACKEND + '/organisation/' + rootGetters['auth/currentUser'].organisation_id
    const headers = { 'Authorization': 'Bearer ' + rootGetters['auth/getToken'] }
    commit('setStatus', { loading: true, error: false, message: '' })
    const response = await axios.put(endpoint, company, { headers: headers })
    if (response.status === 200 || response.status === 204) {
      await dispatch('company/populate', rootGetters['auth/currentUser'].organisation_id, { root: true })
      commit('setStatus', { loading: false, error: false, message: '' })
      return ({ success: true })
    } else {
      commit('setStatus', { loading: false, error: true, message: response.message })
      return ({ success: false })
    }
  },

  async editPublisher ({ commit, dispatch, rootGetters }, company) {
    const endpoint = process.env.VUE_APP_BACKEND + '/publisher/' + rootGetters['auth/currentUser'].publisher_id
    const headers = { 'Authorization': 'Bearer ' + rootGetters['auth/getToken'] }
    commit('setStatus', { loading: true, error: false, message: '' })
    const response = await axios.put(endpoint, company, { headers: headers })
    if (response.status === 200 || response.status === 204) {
      await dispatch('company/populatePublisher', rootGetters['auth/currentUser'].publisher_id, { root: true })
      commit('setStatus', { loading: false, error: false, message: '' })
      return ({ success: true })
    } else {
      commit('setStatus', { loading: false, error: true, message: response.message })
      return ({ success: false })
    }
  },

  async updateImageUrl ({ commit, dispatch, rootGetters }, url) {
    const endpoint = process.env.VUE_APP_BACKEND + '/organisation/' + rootGetters['company/getCompanyData'].id
    const headers = { 'Authorization': 'Bearer ' + rootGetters['auth/getToken'] }
    const response = await axios.put(endpoint, { logo_url: url }, { headers: headers })
    if (response.status === 200 || response.status === 204) {
      let updatedCompany = rootGetters['company/getCompanyData']
      updatedCompany.logo_url = url
      commit('setCompany', updatedCompany)
      return ({ success: true })
    } else {
      return ({ success: false })
    }
  },

  resetCompany ({ commit }) {
    commit('resetCompany')
  }
}

const getters = {
  getCompanyData (state) {
    return state.company ? JSON.parse(state.company) : {}
  },
  getPublisherData (state) {
    return state.publisher ? JSON.parse(state.publisher) : {}
  },
  getStatus (state) {
    return state.status
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
